

<div class="form-modal modal-theme">
  <h1 mat-dialog-title>
    <div class="search-bar">
      <input 
        type="text" 
        [(ngModel)]="searchQuery" 
        placeholder="Pesquise por ícones..." 
        class="search-input"
      />
    </div>
  </h1>
  <div mat-dialog-content class="no-padding-vertical">
    <div>
      <div class="icon-list">
        <div *ngFor="let icon of filteredIcons; let i = index" class="icon-item padding-vertical-15" (click)="selectedIcon = icon" [ngClass]="{'selected': selectedIcon === icon}">
          <div class="icon">
            <i [class]="icon.type + ' fa-' + icon.name"></i>
            <span>{{ icon.label }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}" (click)="dialogRef.close(null)">
        {{'BUTTON.CANCEL' | translate}}
      </button>

      <button type="button" class="btn btn-primary" title="{{'BUTTON.CONFIRM' | translate}}" (click)="dialogRef.close(selectedIcon)" *ngIf="selectedIcon?.name">
        {{'BUTTON.CONFIRM' | translate}}
      </button>
    </div>
  </div>
</div>